
import React, { Fragment, useMemo } from 'react';
import { FormattedMessage } from 'react-intl/dist';

// Utils

import { getFirstEventEnum } from '../../utils/miscellaneous/getVerificationDocumentsConfig';
import { UNSUPPORTED_EVENT } from '../../constants/configs/documentsVerificationConfig';

// Constants

import { checkUserStatus, USER_GROUP_ROLES } from '../../constants/roles/userRoleTypes';
import { configs } from '../../constants/configs/configs';


const EventInfo = props => {

    const {
        event,
        eventNotSupported,
        stateCode,
        userRole,
        validationCompleted
    } = props;

    const isSuperUser = useMemo(
        () => checkUserStatus(USER_GROUP_ROLES.SUPERUSERS, userRole),
        [ userRole ]
    );

    const securedEventName = eventNotSupported ? UNSUPPORTED_EVENT : event;

    const getHeader = () => {
        return (
            <div id = 'qle-event-header' className = 'grid-row header'>
                <div className = 'desktop:grid-col-8 tablet:grid-col-8'>
                    <h3 className = 'heading margin-0'>
                        <FormattedMessage
                            id = { `qle.event.${ securedEventName }` }
                            values = {{ receivedEvent: event }}
                        />
                    </h3>
                </div>
            </div>
        );
    };

    const attestationFormLinkForNewJersey = (
        <a
            className = 'usa-link--external'
            href = { configs.externalEndpoints.NJ_LINKS.EXCEPTIONAL_CIRCUMSTANCES_ATTESTATION_FORM }
            target = '_blank'
            rel = 'noopener noreferrer'
        >
            <FormattedMessage id = 'qle.attestation_form_link.anchor'/>
        </a>
    );

    return (
        <Fragment>
            { getHeader() }
            {
                !validationCompleted ?

                    <div id = 'qle-introduction' className = 'grid-row'>
                        <FormattedMessage
                            id = { `qle.documents.introduction.${getFirstEventEnum(stateCode, securedEventName)}` }
                            values = {{ link: attestationFormLinkForNewJersey }}
                            tagName="p"
                        />
                    </div> :

                    <div id = 'qle-alert' className = 'grid-row'>
                        <div className = 'usa-alert usa-alert--info gi-alert gi-alert__info'>
                            <div className = 'usa-alert__body gi-alert__info__body'>
                                <p className = 'usa-alert__text gi-alert__info__text'>
                                    <FormattedMessage
                                        id = 'qle.documents.status'
                                        values={{
                                            qle: (
                                                <FormattedMessage
                                                    id = { `qle.event.${ securedEventName }` }
                                                    values = {{ receivedEvent: event }}
                                                />
                                            )
                                        }}
                                    />
                                </p>
                                <br/>
                                {
                                    isSuperUser &&

                                    <p className = 'usa-alert__text gi-alert__info__text'>
                                        <FormattedMessage id = 'qle.superusers.ticketed.warning'/>
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
            }
        </Fragment>
    );
};

export default EventInfo;